import LazyLoadImg from "components/LazyLoadImg";
import { RouteName } from "constant/routeNames";
import { Link } from "react-router-dom";
import { RiUserAddFill, RiUserFollowFill } from "react-icons/ri";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaCrown } from "react-icons/fa";

const CreatorCard = ({ isLoading, creator }: any) => {
  const isPremiumContent = creator?.plan_id === 2;
  const isSubscribed = creator?.is_subscribed;
  const creatorFollow = creator?.is_follow;

  return (
    <>
      {!isLoading && (
        <div>
          {creator && (
            <Link
              to={RouteName.VideoCreatorHomeRoute.replace(
                ":slug",
                `@${creator.slug}`,
              )}
            >
              <div className="flex flex-col items-center justify-center w-full px-2 py-2 mx-auto text-center group">
                {/* Premium pill */}
                {isPremiumContent && (
                  <div className="absolute left-1/2 top-1 z-20 flex -translate-x-1/2 items-center gap-1 rounded-full border border-white/15 bg-black/40 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white shadow-lg backdrop-blur-md">
                    <FaCrown className="text-[10px] text-[var(--red)]" />
                    <span>{isSubscribed ? "Subscribed" : "Premium"}</span>
                  </div>
                )}

                <div className="relative mx-auto w-full max-w-[120px]">
                  {/* image */}
                  <div className="relative mx-auto aspect-square w-full overflow-hidden rounded-full ring-1 ring-white/10 transition-all duration-300 group-hover:ring-2 group-hover:ring-[var(--red)]/50">
                    <LazyLoadImg
                      imgSrc={creator?.profile_image || creator?.artwork_url}
                      imgAlt={"Artist"}
                      imgHeight={"100%"}
                      imgWidth={"100%"}
                      wrapperProps={{
                        style: {
                          position: "absolute",
                          inset: 0,
                          width: "100%",
                          height: "100%",
                          display: "block",
                        },
                      }}
                      className="object-cover w-full h-full transition-transform duration-500 ease-out group-hover:scale-110"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </div>

                  {/* follow badge */}
                  {creatorFollow ? (
                    <div
                      className="absolute z-10 bottom-1 right-1"
                      data-tooltip-id={`creator-following-${creator?.id}`}
                    >
                      <RiUserFollowFill className="h-9 w-9 rounded-full bg-[var(--green)] p-2 text-black shadow-lg" />
                      <div className="z-50 text-sm">
                        <ReactTooltip
                          place="top"
                          id={`creator-following-${creator?.id}`}
                          content="Following"
                          style={{ width: "100px", borderRadius: "20px" }}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="absolute z-10 bottom-1 right-1"
                      data-tooltip-id={`creator-follow-${creator?.id}`}
                    >
                      <RiUserAddFill className="h-9 w-9 rounded-full bg-[var(--green)] p-2 text-black shadow-lg" />
                      <div className="z-50 text-sm">
                        <ReactTooltip
                          place="top"
                          id={`creator-follow-${creator?.id}`}
                          content="Follow"
                          style={{ width: "100px", borderRadius: "20px" }}
                        />
                      </div>
                    </div>
                  )}
                </div>

                <p className="mt-3 w-full justify-center text-center text-[14px] font-[600] text-white transition-colors group-hover:text-white">
                  {creator?.name}
                </p>
              </div>
            </Link>
          )}
        </div>
      )}
    </>
  );
};

export default CreatorCard;
